import { useState } from "react";
import { Table, Pagination, ConfigProvider } from "antd";
import styles from "./CustomTable.module.scss";

const CustomTable = ({ columns, mockData }) => {
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  return (
    <div>
      <ConfigProvider
        theme={{
          components: {
            Table: {
              colorBgContainer: "transparent",
              colorPrimaryBorder: "var(--border-primary)",
              borderRadius: "15",
              headerBg: "#F4F4F6",
              colorText: "var(--text-primary)",
              fontWeightStrong: "400",
              rowHoverBg: "#F4F4F6",
            },
          },
        }}
      >
        <Table
          columns={columns}
          dataSource={mockData.slice(
            (currentPage - 1) * pageSize,
            currentPage * pageSize
          )}
          pagination={false}
          rowKey="key"
        />
      </ConfigProvider>

      <div className={styles.tableFooter}>
        <ConfigProvider
          theme={{
            components: {
              Pagination: {
                colorText: "var(--text-primary)",
                itemBg: "transparent",
                itemActiveBg: "transparent",
              },
            },
          }}
        >
          <Pagination
            current={currentPage}
            total={mockData.length}
            pageSize={pageSize}
            onChange={setCurrentPage}
            showSizeChanger={false}
            itemBg="black"
          />
        </ConfigProvider>
      </div>
    </div>
  );
};

export default CustomTable;
